module.exports = __webpack_public_path__ + "img/586-587-preview.4377470a.jpg";